// Each assignment belongs to a cost-sheet LINE, never just a material ID.
// Old contrast fields remain separate and are never inferred as assignments.
export function materialColorAssignment(row, material) {
  const key = material.source_line_id || material.id;
  const assignment = row.material_colors?.[key];
  if (assignment?.not_applicable || (!assignment && material.requires_color !== true)) return { color: 'Sin color', pending: false };
  return { color: assignment?.color?.trim() || 'Color pendiente', pending: !assignment?.color?.trim() };
}

export function materialColorNeeds(material, rows = [], { waste = true } = {}) {
  const groups = new Map();
  for (const row of rows) {
    const garments = Number(row.total ?? row.total_quantity ?? 0);
    if (garments <= 0) continue;
    const assignment = materialColorAssignment(row, material);
    const key = JSON.stringify([assignment.color, assignment.pending]);
    if (!groups.has(key)) groups.set(key, { ...assignment, totalQuantity: 0 });
    groups.get(key).totalQuantity += garments * Number(material.quantity_per_unit ?? material.quantity ?? 0)
      * (waste ? 1 + Number(material.waste_pct || 0) / 100 : 1);
  }
  return [...groups.values()].map((row) => ({ ...row, totalQuantity: Number(row.totalQuantity.toFixed(4)) }));
}

export function colorVariantFields(row = {}) {
  return { variant_id: row.variant_id || null, garment_color: row.garment_color || row.color || '', material_colors: row.material_colors || {} };
}

export function nextVariantKey(color, existing = []) {
  if (!existing.includes(color)) return color;
  let index = 2;
  while (existing.includes(`${color} · Variante ${index}`)) index += 1;
  return `${color} · Variante ${index}`;
}

export function snapshotMaterialColors(sheet, assignments = {}) {
  const result = { ...assignments };
  const lines = [...(sheet?.material_lines || []), ...(sheet?.orphan_material_lines || []), ...(sheet?.process_lines || []).flatMap((p) => p.material_lines || [])];
  for (const line of lines) {
    if (!line.id) continue;
    result[line.id] = { ...assignments[line.id], color: assignments[line.id]?.color || '',
      not_applicable: line.requires_color !== true,
      requires_color: line.requires_color === true,
      usage: line.color_usage || '', name: line.material?.internal_description || '',
      reference: line.material_supplier?.supplier_ref || line.material?.code || '',
      supplier: line.material_supplier?.supplier?.name || '',
    };
  }
  return result;
}

export function sheetFromColorAssignments(rows = [], sheet = null) {
  // Manufacturing cost lines exclude some processes whose materials still need
  // colours for documents. Only the full sheet can identify current columns.
  // Assignments stay on the rows, including history and deliberately empty colours.
  if (sheet) return sheet;
  const lines = new Map();
  for (const row of rows) for (const [id, assignment] of Object.entries(row.material_colors || {})) {
    if (!lines.has(id)) lines.set(id, { id, color_usage: assignment.usage || '', requires_color: assignment.requires_color ?? (!assignment.not_applicable && Boolean(assignment.color)),
      material: { internal_description: assignment.name || assignment.reference || 'Material' },
      material_supplier: { supplier_ref: assignment.reference || '', supplier: { name: assignment.supplier || '' } },
    });
  }
  return { material_lines: [...lines.values()] };
}
